import { SubscribeRequestData } from '../../../typings';

import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function putUnsubscribeCourse(data: SubscribeRequestData): Promise<void> {
    const { apiPutUnsubscribeCourse } = apiConfig.getStaticUrls();

    return postFetch(apiPutUnsubscribeCourse, { data });
}

